<template>
    <div v-if="config" class=" bg-background-inverse-1 opacity-80 py-3 px-4 rounded-02 pointer-events-auto" >
        <div class="flex text-content-inverse-1">
            <div :class="[processStatus === ('PROCESSING' && showProgressStep)? 'py-[5px] grid grid-rows-2' : 'flex items-center']">
                <template  v-if="processStatus=='PROCESSING'">
                    <shapeIcon :width="19" :height="19" weight="THIN" color="text-white animate-spin"/>
                    <div v-if="showProgressStep" class="font-inter-caption-3">
                        {{ progressText }}
                    </div>
                </template>
                <checkCircleIcon v-else-if="processStatus=='FINISHED'" :width="24" :height="24"  weight="FILL" color="text-accent-green-3"/>
                <errorIcon v-else-if="processStatus=='FAIL'" color="text-accent-red-3" :width="24" :height="24"  weight="FILL"/>

            </div>

            <div class="py-[5px] px-[2px] ml-2">
                <div class="font-inter-heading-18">{{ config.heading }}</div>
                <div
                    class="font-inter-caption-3 truncate"
                    :style="{ width : config.textWidth + 'px' }"
                >
                    <slot name="subtitle">
                    </slot>
                </div>
            </div>

            <designButton
                v-if="config.buttonAction"
                class="ml-3 self-center"
                btn-type="QUATERNARY"
                btn-size="XS"
                :btn-text="config.buttonAction.text"
                :btn-disabled="false"
                @click="$emit('goBackToList')"
            />

            <div class="pl-3 ml-1 flex items-center cursor-pointer" @click="emitAction(config.closeAction)">
                <closeIcon color="text-content-inverse-1" :width="16" :height="16" />
            </div>
        </div>
    </div>
</template>

<script>
import designButton from '@/components/design-system/design-button.vue';
import errorIcon from '@/components/design-system/icon/error.vue';
import closeIcon from '@/components/design-system/icon/close.vue';
import checkCircleIcon from '@/components/design-system/icon/check-circle.vue';
import shapeIcon from '@/components/design-system/icon/shape.vue';

export default {
    name: 'PayrollProgressBox',
    components: {
        designButton,
        errorIcon,
        closeIcon,
        checkCircleIcon,
        shapeIcon,
    },
    props: {
        stepTotal : { type : [Number, String], default: 5 },
        current: { type: [Number, String], default: 0 },
        title: { type: String, required: false },
        // 상태값: PROCESSING | FINISHED | FAIL 
        processStatus: {
            type: String,
            default: 'PROCESSING',
            validator: (v) => ['PROCESSING', 'FINISHED', 'FAIL'].includes(v),
        },
        showProgressStep : { type : Boolean, default : false },
        statusConfig : {
            type : Object, 
        }
    },
    emits: ['close', 'view', 'goBackToList', 'closeConfirm'],
    data() {
        return {
            
        };
    },
    computed: {
        config() {
            return this.statusConfig[this.processStatus] || null;
        },
        progressText() {
            if( !this.showProgressStep ) {
                return;
            }
            return `${this.current}/${this.stepTotal}`;
        },
        payrollName() {
            return `Payroll Name : ${this.title}`;
        },
    },
    methods: {
        emitAction(event) {
            this.$emit(event);
        },
    },
};
</script>
